import numeral from 'numeral';

export default function(rut) {
    if (rut === null) return '';

    const splitted = rut.split('-');

    if (splitted.length !== 2) return rut;

    return numeral(splitted[0]).format('0,0') + '-' + splitted[1];
}



// WEBPACK FOOTER //
// ./resources/assets/js/Methods/RutFormatter.js